<template>
  <div>
    <h2>收入类别</h2>
    <div class="search">
      <el-form :inline="true" class="searchForm" :model="searchForm" ref="searchForm" label-suffix="：" size="medium">
        <el-form-item label="状态">
          <el-select filterable v-model="searchForm.STATUS" placeholder="请选择">
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型">
          <el-select filterable v-model="searchForm.INCOME_CATEGORY" placeholder="请选择">
            <el-option v-for="item in incomeCategoryList" :key="item.typeId" :label="item.name" :value="item.typeId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button @click="search">筛选</el-button>
        <el-button type="text" style="color: rgb(96,98,102)" @click="clear()">重置筛选条件</el-button>
      </el-form>
    </div>
    <el-row>
      <el-col :span="4">
        <el-button size="small" @click="addFormVisible = true" style="margin-bottom:10px;">新增</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="incomeTypeListData" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
          <el-table-column prop="NAME" label="名称" min-width="100"></el-table-column>
          <el-table-column prop="FEE_RATIO" label="手续费率（%）" min-width="100"></el-table-column>
          <el-table-column prop="STATUS" label="状态" min-width="100">
            <template slot-scope="scope">
              <el-tag>{{ showStatusLable(scope.row.STATUS) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="INCOME_CATEGORY" label="类型" min-width="100">
            <template slot-scope="scope">
              {{ incomeCategoryList.find(({ typeId }) => typeId == scope.row.INCOME_CATEGORY).name }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="300">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-edit-outline" @click="editType(scope.row)">
                修改
              </el-button>
              <el-button type="text" size="small" icon="el-icon-edit-outline" @click="incomesType(scope.row)">
                收入方式
              </el-button>
              <el-button type="text" size="small" icon="el-icon-edit-outline" @click="useType(scope.row)"
                v-if="scope.row.STATUS == 0">
                启用
              </el-button>
              <el-button type="text" style="color:red" size="small" icon="el-icon-edit-outline"
                @click="useNotType(scope.row)" v-if="scope.row.STATUS == 1">
                禁用
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="block">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalNum">
      </el-pagination>
    </div>
    <!-- 新增收入类别模态框 -->
    <el-dialog title="新增收入类别" center :visible.sync="addFormVisible" width="600px" :close-on-click-modal="false">
      <el-form :model="addForm" ref="addForm" :rules="rules" style="margin-top: 0">
        <el-form-item label="名称：" :label-width="formLabelWidth" prop="name">
          <el-input v-model="addForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="费率：" :label-width="formLabelWidth" prop="ratio">
          <el-input v-model="addForm.ratio" auto-complete="off" clearable>
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item label="类型：" :label-width="formLabelWidth">
          <el-select v-model="addForm.INCOME_CATEGORY" placeholder="请选择" style="width: 350px;">
            <el-option v-for="item in incomeCategoryList" :key="item.typeId" :label="item.name" :value="item.typeId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close('addForm')">取 消</el-button>
        <el-button @click="submitAdd('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!--修改收入类别模态框 -->
    <el-dialog title="修改收入类别" center :visible.sync="editFormVisible" width="600px" :close-on-click-modal="false">
      <el-form :model="editForm" ref="editForm" :rules="rules" style="margin-top: 0">
        <el-form-item label="名称：" :label-width="formLabelWidth" prop="NAME">
          <el-input v-model="editForm.NAME" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="费率：" :label-width="formLabelWidth" prop="FEE_RATIO">
          <el-input v-model="editForm.FEE_RATIO" auto-complete="off" clearable>
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item label="类型：" :label-width="formLabelWidth">
          <el-select v-model="editForm.INCOME_CATEGORY" placeholder="请选择" style="width: 350px;">
            <el-option v-for="item in incomeCategoryList" :key="item.typeId" :label="item.name" :value="item.typeId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close('editForm')">取 消</el-button>
        <el-button @click="submitEdit('editForm')" plain>确 定</el-button>
      </div>
    </el-dialog>
    <!--修改收入方式模态框-->
    <el-dialog title="上报方式" center :visible.sync="incomesTypeVisible" width="450px" :close-on-click-modal="false">
      <el-form :model="incomesTypeForm" ref="incomesTypeForm" :rules="rules" style="margin-top: 0">
        <el-form-item label="上报方式：" :label-width="formLabelWidth">
          <el-select v-model="incomesTypeForm.value" placeholder="请选择">
            <el-option v-for="item in PRODUCT_TYPE_LIST" :key="item.typeId" :label="item.name" :value="item.typeId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="同步类型：" :label-width="formLabelWidth" v-if="this.incomesTypeForm.value == 1">
          <el-select v-model="incomesTypeForm.valuet" placeholder="请选择">
            <el-option v-for="item in PRODUCT_TYPE_LISTT" :key="item.typeId" :label="item.name" :value="item.typeId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收入类型：" :label-width="formLabelWidth" v-else>
          <el-select v-model="incomesTypeForm.valuef" placeholder="请选择">
            <el-option v-for="item in PRODUCT_TYPE_LISTF" :key="item.typeId" :label="item.name" :value="item.typeId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="incomesTypeVisible = false">取 消</el-button>
        <el-button @click="submitIncomesType" plain>确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  incomeTypeList, addIncomeType, editIncomeType,
} from '@/api/incomeType';
import util from '@/common/util';
import http from '@/api/base/http';

export default {
  data() {
    const name = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,100}$/;
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback('内容不能为空');
      } else if (name.test(value)) {
        callback();
      } else {
        callback('您输入的格式有误');
      }
    };

    const cost = /^[1-9]\d*|0\,\d*|[1-9]\d*|0$/;
    const validateCost = (rule, value, callback) => {
      if (value === '') {
        callback('内容不能为空');
      } else if (cost.test(value)) {
        callback();
      } else {
        callback('您输入的格式有误');
      }
    };

    return {
      searchForm: {
        STATUS: '',
      },
      statusList: [
        {
          label: '禁用',
          value: '0',
        },
        {
          label: '启用',
          value: '1',
        },
      ],
      STATUS_LIST: ['已禁用', '已启用'],
      incomeTypeListData: [],
      totalNum: 0,
      typeData: [{ NAME: '支付宝', STATUS: 1 }],
      formLabelWidth: '150px',
      addFormVisible: false,
      editFormVisible: false,
      pageSize: 10,
      currentPage: 1,
      addForm: {
        name: '',
        ratio: '',
      },
      editForm: {
        NAME: '',
        FEE_RATIO: '',
      },
      incomeCategoryList: [{ typeId: 0, name: '不分类' }, { typeId: 1, name: '餐费' }, { typeId: 2, name: '管理费' }, { typeId: 3, name: '食材销售' }],
      PRODUCT_TYPE_LIST: [{ typeId: 0, name: '手动录入' }, { typeId: 1, name: '自动同步' }],
      PRODUCT_TYPE_LISTT: [{ typeId: 1, name: '采购即收入' }, { typeId: 2, name: '成本即收入' }],
      PRODUCT_TYPE_LISTF: [{ typeId: 0, name: '按日上报' }, { typeId: 3, name: '按月上报' }],
      incomesTypeForm: {
        value: '',
        valuet: 1,
        valuef: 0,
        ID: '',
        IS_INCLUDED_IN_INVOICE_AMOUNT: 1,
      },
      incomesTypeVisible: false,
      options: [
        {
          value: 0,
          label: '手动录入',
        },
        {
          value: 1,
          label: '自动同步',
          children: [{
            value: 1,
            label: '采购即收入',
          }, {
            value: 2,
            label: '成本即收入',
          }],
        },

      ],
      rules: {
        name: [
          { required: true, validator: validateName, trigger: 'blur' },
        ],
        ratio: [
          { required: true, validator: validateCost, trigger: 'blur' },
        ],
        NAME: [
          { required: true, validator: validateName, trigger: 'blur' },
        ],
        FEE_RATIO: [
          { required: true, validator: validateCost, trigger: 'blur' },
        ],

      },
    };
  },
  methods: {
    search() {
      this.currentPage = 1;
      this.queryData();
    },
    clear() {
      this.searchForm = {};
    },
    showStatusLable(index) {
      return this.STATUS_LIST[index];
    },
    // 获取收入类别
    queryData() {
      const data = {
        PAGE_INDEX: this.currentPage - 1,
        PAGE_SIZE: 10,
        TC_ID: Number(sessionStorage.getItem('companyId')),
      };
      for (const key in this.searchForm) {
        if (this.searchForm[key]) {
          data[key] = this.searchForm[key];
        }
      }
      incomeTypeList(data).then((res) => {
        if (res.length) {
          this.incomeTypeListData = res[0].OP_ROLE;
          this.totalNum = res[0].TOTAL_COUNT;
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 收入方式
    incomesType(row) {
      this.incomesTypeForm.ID = row.TYPE_ID;
      const params = {
        SERVICE_ID: '10007',
        OTYPE: 5,
        TC_ID: Number(sessionStorage.getItem('companyId')),
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        TYPE_ID: row.TYPE_ID,
      };
      http.post(params).then((result) => {
        if (result[0].AUTO_TYPE > 0 && result[0].AUTO_TYPE < 3) {
          this.incomesTypeForm.valuet = result[0].AUTO_TYPE;
          this.incomesTypeForm.value = 1;
        } else {
          this.incomesTypeForm.valuef = result[0].AUTO_TYPE;
          this.incomesTypeForm.value = 0;
        }
        this.incomesTypeVisible = true;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitIncomesType() {
      const params = {
        SERVICE_ID: '10007',
        OTYPE: 6,
        TC_ID: Number(sessionStorage.getItem('companyId')),
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        TYPE_ID: this.incomesTypeForm.ID,

      };
      if (this.incomesTypeForm.value > 0) {
        params.AUTO_TYPE = this.incomesTypeForm.valuet;
      } else {
        params.AUTO_TYPE = this.incomesTypeForm.valuef;
      }
      if (this.incomesTypeForm.value == 1 && !this.incomesTypeForm.valuet && !this.incomesTypeForm.valuef) {
        this.$message.show({ text: '请选择同步类型', type: 'warning' });
        return false;
      }
      http.post(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.incomesTypeVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitKaiPiao(ID, AUTO_TYPE) {
      const params = {
        SERVICE_ID: '10007',
        OTYPE: 10,
        TC_ID: Number(sessionStorage.getItem('companyId')),
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        TYPE_ID: ID,
        AUTO_TYPE,
        IS_INCLUDED_IN_INVOICE_AMOUNT: this.incomesTypeForm.IS_INCLUDED_IN_INVOICE_AMOUNT,

      };
      http.post(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.incomesTypeVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 新增收入类别
    submitAdd(formName) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const data = {
            TC_ID: Number(sessionStorage.getItem('companyId')),
          };
          if (this.addForm.name) {
            data.NAME = this.addForm.name;
          } else {
            this.$message.show({ text: '请填写名称', type: 'warning' });
            document.body.style.cursor = 'default';
            return;
          }
          if (this.addForm.INCOME_CATEGORY) {
            data.INCOME_CATEGORY = this.addForm.INCOME_CATEGORY;
          } else {
            data.INCOME_CATEGORY = 0;
          }
          if (this.addForm.ratio) {
            data.FEE_RATIO = Number(this.addForm.ratio);
          } else {
            this.$message.show({ text: '请填写税率', type: 'warning' });
            document.body.style.cursor = 'default';
            return;
          }
          addIncomeType(data).then((res) => {
            this.$message.show({ text: '新增成功', type: 'success' });
            this.queryData();
            this.addFormVisible = false;
            this.$refs[formName].resetFields();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    // 修改收入类别
    submitEdit(formName) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const data = {
            TC_TYPE_ID: this.editForm.ID,
            FEE_RATIO: Number(this.editForm.FEE_RATIO),
          };
          if (this.editForm.INCOME_CATEGORY) {
            data.INCOME_CATEGORY = this.editForm.INCOME_CATEGORY;
          } else {
            data.INCOME_CATEGORY = 0;
          }
          editIncomeType(data).then((res) => {
            this.$message.show({ text: '修改成功', type: 'success' });
            this.queryData();
            this.editFormVisible = false;
            this.$refs[formName].resetFields();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    editType(row) {
      this.editFormVisible = true;
      this.editForm = util.deepCopy(row);
    },
    useType(row) {
      const params = {
        SERVICE_ID: '10007',
        OTYPE: 12,
        USER_ID: Number(sessionStorage.getItem('userId')),
        TC_ID: Number(sessionStorage.getItem('companyId')),
        SESSION: sessionStorage.getItem('session'),
        TYPE_ID: row.TYPE_ID,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '启用成功', type: 'success' });
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    useNotType(row) {
      const params = {
        SERVICE_ID: '10007',
        OTYPE: 11,
        USER_ID: Number(sessionStorage.getItem('userId')),
        TC_ID: Number(sessionStorage.getItem('companyId')),
        SESSION: sessionStorage.getItem('session'),
        TYPE_ID: row.TYPE_ID,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '禁用成功', type: 'warning' });
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 关闭弹窗
    close(formName) {
      this.$refs[formName].resetFields();
      const modalName = `${formName}Visible`;
      this[`${modalName}`] = false;
    },
    handleCurrentChange() {
      this.queryData();
    },
  },
  mounted() {
    this.queryData();
  },
};
</script>
<style>
.block {
  float: right;
}

.el-cascader-menu {
  height: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/incomeType.vue